module.exports = __webpack_public_path__ + "2e5ceb74685c746e8734c0397eb0f3b4.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1123
// module chunks = 0